import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Extra } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteExtra, useExtra, useUpdateExtra } from '../../hooks/extra'
import ExtraForm from '../../components/ExtraForm'

export default function ExtraEdit() {
  const { id } = useParams()
  const { data: extra } = useExtra(+id!)
  const deleteExtra = useDeleteExtra()
  const updateExtra = useUpdateExtra()
  const [modalRm, modalRmActions] = useModalTrigger<Extra>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/extras">Extra</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {extra!.title.it}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <a
            className="btn btn-primary me-2"
            href={'https://www.memoryscapes.it/it/extra/' + extra!.id}
            target="_blank"
          >
            <i className="bi bi-eye me-2"></i> Visualizza Preview
          </a>
          <button
            className="btn  btn-danger"
            onClick={() => modalRmActions.open(extra)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <ExtraForm
          extra={extra}
          save={(formExtra) =>
            updateExtra.mutateAsync(formExtra).then(() =>
              toast.success('Extra salvato con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare l'extra {modalRm.value.title.it} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteExtra.isLoading}
            onClick={async () => {
              await deleteExtra.mutateAsync(modalRm.value!.id)
              navigate('/series')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
